import { useEffect, useState } from 'react';
import './AccessDenied.css';

const AccessDenied = ({ showHeader }) => {
  const [shake, setShake] = useState("shake");
  useEffect(() => {
    setInterval(() => {
      setShake("");
    }, 500);
  }, []);
  return (
    <div className="not-found">
      <div>
        <h1 className={shake}>Access Denied</h1>
        <p>Please contact admin for the Access</p>
      </div>
    </div>
  );
};

export default AccessDenied;
